import React, { Suspense, lazy } from "react";
import SignUp from "./components/signup/signupnew";
import Login from "./components/login/login";
import Dashboard from "./components/dashboard/dashboard";
// import Classboard from './components/class/class'
import RegisterProfile from "./components/register-profile/register-profile";
// import RegisterInstitute from './components/register-institute/register-institute';
// import Profile from './components/profile/profile';
import ForgotPassword from "./components/forgot-password/forgot-password";
import ResetPassword from "./components/reset-password/reset-password";
import BaseTheme from "./theme/base-theme";
import { ThemeProvider } from "@material-ui/styles";
import "./App.css";
import "katex/dist/katex.min.css";
import { Route, Switch, withRouter } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import { withStyles } from "@material-ui/core/styles";

import { PrivateRoute } from "./utils/PrivateRoute";

import { withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import SchedulerWebView from "./components/SchedulerWebView/SchedulerWebView";
import {SchedulerWebViewConfig} from "./components/SchedulerWebView/SchedulerWebViewConfig";

// import IWBPage from "./Kneura-Web-Whiteboard/IWB/IWB";
import { connect } from "react-redux";
import { clearError } from "./store/actions/error.action";
import StartTest from "./components/Assignment/components/StartTestPage/StartTest";
import CompleteAssignment from "./components/Assignment/components/CompleteAssignment/CompleteAssignment";
import AssignmentResult from "./components/Assignment/components/CompleteAssignment/AssignmentResult/AssignmentResult";
import Solution from "./components/Assignment/components/CompleteAssignment/SolutionsPage/seeSolutions";
import { LinearProgress } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
// import IWB_BBB from "./components/bbb.bak/iwf-bbb";
import loginFromWebSite from "./components/login/loginFromWebSite";
// import LessonPlan from "./components/lesson-plan/component";
import GoLive from "./components/lesson-plan/go-live/component";
import EvaluationPending from "./components/Assignment/components/CompleteAssignment/EvaluationPending/EvaluationPending";
import { LIVE_CLASS } from "./utils";
import liveClassService, {
  LIVE_CLASS_TYPE,
} from "./store/services/live-class.service";
import { WEBSITE_URL } from "./config";
import { AssessmentAttempt } from "./components/webviews/assessmentAttempt";
import AssessmentWebViewList from "./components/Assignment/containers/AssessmentWebViewList/AssessmentWebViewList";
import { AssessmentFullWebView } from "./components/webviews/assessmentFull";
import {
  connectToAssessmentSocket,
  disconnectAssessmentSocket,
} from "./store/services/assessmentSocket.service";
import ClassFeedWebView from './components/Students/ClassFeedWebView';
import { ClassFeedSetter } from './components/Students/ClassFeedSetter';

const LessonPlan = lazy(() => import("./components/lesson-plan/component"));


class App extends React.Component {
  constructor(props) {
    super(props);
    App.context = this;
  }

  state = {
    openerrmsg: false,
    errmsg: "",
    showloader: false,
    isOnline: true,
    showError: false,
    errorMessage: "",
  };

  static showError(msg) {
    App.context.setState({
      ...App.context.state,
      showError: true,
      errorMessage: msg,
    });
  }

  static hideError() {
    App.context.setState({
      ...App.context.state,
      showError: false,
      errorMessage: "",
    });
  }

  static navigateToLogin() {
    // App.context.props.history.replace("/login");
    window.location.replace(WEBSITE_URL);
  }

  openSnackbar = () => {
    this.setState({ openerrmsg: true, errmsg: "Error message" });
    this.setState({ showloader: !this.state.showloader });
  };

  componentWillReceiveProps(props) {
    if (props.errorMessage != "")
      this.setState({ openerrmsg: true, errmsg: props.errorMessage });
    setTimeout(() => {
      this.props.clearError();
    }, 3000);
    //this.props.clearError();
  }

  checkOffline() {
    setInterval(() => {
      navigator.onLine ? App.hideError() : App.showError("YOU ARE OFFLINE");
    }, 10000);
  }

  static showProgress() {
    if (typeof App.context === "undefined") return;
    App.context.setState({
      ...App.context.state,
      showloader: true,
    });
  }

  static hideProgress() {
    if (typeof App.context === "undefined") return;
    App.context.setState({
      ...App.context.state,
      showloader: false,
    });
  }

  componentDidMount() {
    connectToAssessmentSocket();
    this.checkOffline();
    // this.connectLiveClassSocket();
    // liveClassService.onConnected({ callback: this.handleLiveClassConnected })
  }

  componentWillUnmount() {
    disconnectAssessmentSocket();
    // liveClassService.disconnectSocket();
  }



  handleAuthenticationSuccess = (msg) => {

  };

  handleLiveClassSockerError = (err) => {

  };

  connectLiveClassSocket() { }

  render() {
    const { classes, t } = this.props;
    return (
      <React.Fragment>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={!this.state.isOnline}
          message={<span>YOU ARE OFFLINE</span>}
        ></Snackbar>
        <ThemeProvider theme={BaseTheme}>
          {this.props.showloader ? (
            <LinearProgress
              style={{
                position: "absolute",
                zIndex: "100",
                width: "100%",
                top: "0",
              }}
              classes={{
                colorPrimary: classes.colorPrimary,
                barColorPrimary: classes.barColorPrimary,
              }}
            />
          ) : (
              ""
            )}
          <Suspense
            fallback={
              <div className="loader">
                <CircularProgress size={100} thickness={2} />
                <div> Loading . . .</div>
              </div>
            }
          >
            <Switch>
              <Route exact path="/" component={Login} />
              <Route
                path={"/assessments/evaluation-pending"}
                component={EvaluationPending}
              />
              <Route path="/signup" component={SignUp} />
              <Route path="/login" component={Login} />
              <Route path="/register-profile" component={RegisterProfile} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/start-test" component={StartTest} />
              <Route
                path="/assessment-list-webview"
                component={AssessmentWebViewList}
              />
              <Route
                exact
                path="/webview/learn/assessment/full/:classId"
                component={AssessmentFullWebView}
              />
              <Route path="/test" component={CompleteAssignment} />
              <Route path="/test-submitted" component={AssignmentResult} />
              <Route path="/forgotpassword" component={ForgotPassword} />
              <Route path="/resetpassword" component={ResetPassword} />
              <Route path="/seesolution" component={Solution} />
              <Route exact path="/goLive/:whiteboardID" component={GoLive} />
              <Route
                exact
                path="/webview/assessment/attempt/:assessmentId"
                component={AssessmentAttempt}
              />

              <Route exact path="/webview/classFeed/full/:classId" component={ClassFeedSetter} />
              <PrivateRoute
                path={"/class"}
                render={(props) => <LessonPlan {...props}></LessonPlan>}
              />

              {/* <PrivateRoute
              path={"/class"}
              render={props => <IWBPage {...props} role={"learner"} />}
            /> */}
              {/* <PrivateRoute
              path={"/class"}
              render={props => <IWB_BBB {...props} />}
            /> */}

              {/* <Route
              exact
              path="/whiteboard/:whiteboardID"
              render={() => <IWB_BBB></IWB_BBB>}
            ></Route> */}
                <Route
                  path="/scheduler-webview"
                  render={(props) => <SchedulerWebView {...props} />}
                />

               <Route exact path="/webview/scheduler" component={SchedulerWebViewConfig} />
              <Route path="/learnLogin" component={loginFromWebSite} />
            </Switch>
          </Suspense>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={this.state.showError}
            message={<span>{this.state.errorMessage}</span>}
          />
        </ThemeProvider>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { errors, loader } = state;
  return {
    errorMessage: errors.errorMessage,
    showloader: loader.showLoader,
  };
};

const styles = (props) => ({
  colorPrimary: {
    backgroundColor: "#0074e4",
  },
  barColorPrimary: {
    backgroundColor: "#fff",
  },
});

export default connect(mapStateToProps, { clearError })(
  withStyles(styles)(hoistStatics(withTranslation()(withRouter(App)), App))
);
//export default App;
